import { ThemeProvider } from '@worthy-npm/worthy-common-ui-components';
import { buyersTheme } from '@worthy-npm/worthy-common-ui-components/theme';
import Login from 'pages/Login';
import RegistrationForm from 'pages/RegistrationForm';
import { unstable_HistoryRouter as Router, Route, Routes } from 'react-router';
import { history } from 'state/store';

const Views = () => {
  const isLocalDev =
    process.env.REACT_APP_ENV === 'local' && process.env.PUBLIC_URL === window.location.origin;
  const isTest = process.env.REACT_APP_ENV === 'test';

  return (
    <ThemeProvider theme={buyersTheme}>
      {(isLocalDev || isTest) && (
        <>
          <div>
            <div id="buyers_login_link" />
          </div>
          <div id="login-block" />
        </>
      )}
      <Router
        // @ts-ignore
        history={history}
        basename="/buyers"
      >
        <Routes>
          <Route
            path={'/registration_form'}
            element={<RegistrationForm />}
          />
          <Route
            path={'/sign_in'}
            element={<Login />}
          />
        </Routes>
      </Router>
      <Router
        // @ts-ignore
        history={history}
      >
        <Routes>
          <Route
            path="*"
            element={<Login />}
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default Views;
